/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.p, null, "Hi! Welcome to my very first blog :)"), "\n", React.createElement(_components.p, null, "First of all, a little bit about myself. For the last five years or so I have been developing websites for others so recently thought of why don’t build one for myself?"), "\n", React.createElement(_components.p, null, "Now here I am."), "\n", React.createElement(_components.p, null, "Here I wish to share my knowledge, experience and more. All the content will be my own and the images published will be either I made, like the one in this post (it is my visual studio), or will be from ", React.createElement(_components.a, {
    href: "http://unsplash.com",
    target: "_blank",
    rel: "nofollow noopener"
  }, "unsplash"), "."), "\n", React.createElement(_components.p, null, "This is a work in progress website so you may notice some broken parts but I will fix em as per my free time."));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
